import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface BookingState {
  guest: number;
  date: string;
  time: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  request: string;
  organizationDetails: any;
  shiftDetails: any;
  availableSpots: any;
  availableDaySpots: any;
  tableDuration: number;
  bookingDetails: any;
  locationId: string;
  floorData: any[];
  bookingStatus: any[];
  bookingTags: any[];
  allocatedTables: any[];
  selectedFloorData: any;
  allFloorDetails: any[];
  floorLayoutData: any[];
  islocationSwitching: boolean;
  defaultFloorLayoutData: any[];
  isBlockOpen: boolean;
  isBlockTableOpen: boolean;
  prePaymentData: any;
}

const initialState: BookingState = {
  guest: JSON.parse(localStorage.getItem("resGuest") || "0"),
  date: localStorage.getItem("resDate") || new Date().toDateString(),
  time: localStorage.getItem("resTime") || "",
  firstName: localStorage.getItem("fName") || "",
  lastName: localStorage.getItem("lName") || "",
  email: localStorage.getItem("email") || "",
  phoneNumber: localStorage.getItem("phone") || "",
  request: localStorage.getItem("request") || "",
  organizationDetails: JSON.parse(localStorage.getItem("org") || "{}"),
  shiftDetails: JSON.parse(localStorage.getItem("shifts") || "[]"),
  availableSpots: [],
  availableDaySpots: [],
  tableDuration: JSON.parse(localStorage.getItem("resDuration") || "0"),
  bookingDetails: [],
  locationId: localStorage.getItem("wrlId") || "",
  floorData: [],
  bookingStatus: JSON.parse(localStorage.getItem("status") || "[]"),
  bookingTags: JSON.parse(localStorage.getItem("tags") || "[]"),
  allocatedTables: [],
  selectedFloorData: {},
  allFloorDetails: [],
  floorLayoutData: [],
  islocationSwitching: false,
  defaultFloorLayoutData: [],
  isBlockOpen: false,
  isBlockTableOpen: false,
  prePaymentData: null,
};
const bookingSlice = createSlice({
  name: "bookingReducer",
  initialState,
  reducers: {
    setGuest(state, action: PayloadAction<number>) {
      state.guest = action.payload;
      let value = action.payload === undefined ? 0 : action.payload;
      localStorage.setItem("resGuest", JSON.stringify(value));
    },
    setDate(state, action: PayloadAction<string>) {
      state.date = action.payload;
      localStorage.setItem("resDate", action.payload);
    },
    setTime(state, action: PayloadAction<string>) {
      state.time = action.payload;
      localStorage.setItem("resTime", action.payload);
    },
    setFirstName(state, action: PayloadAction<string>) {
      state.firstName = action.payload;
      localStorage.setItem("fName", action.payload);
    },
    setLastName(state, action: PayloadAction<string>) {
      state.lastName = action.payload;
      localStorage.setItem("lName", action.payload);
    },
    setEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
      localStorage.setItem("email", action.payload);
    },
    setPhoneNumber(state, action: PayloadAction<string>) {
      state.phoneNumber = action.payload;
      localStorage.setItem("phone", action.payload);
    },
    setRequest(state, action: PayloadAction<string>) {
      state.request = action.payload;
      localStorage.setItem("request", action.payload);
    },
    setOrganizationalDetails(state, action: PayloadAction<any>) {
      state.organizationDetails = action.payload;
    },
    setShiftDetails(state, action: PayloadAction<any>) {
      state.shiftDetails = action.payload;
    },
    setAvailableSpots(state, action: PayloadAction<any>) {
      state.availableSpots = action.payload;
    },
    setAvailableDaySpots(state, action: PayloadAction<any>) {
      state.availableDaySpots = action.payload;
    },
    setTableDuration(state, action: PayloadAction<number>) {
      state.tableDuration = action.payload;
      let value = action.payload === undefined ? 0 : action.payload;
      localStorage.setItem("resDuration", JSON.stringify(value));
    },
    setBookingDetails(state, action: PayloadAction<any>) {
      state.bookingDetails = action.payload;
    },
    setLocationId(state, action: PayloadAction<string>) {
      state.locationId = action.payload;
    },
    setFloorData(state, action: PayloadAction<[]>) {
      state.floorData = action.payload;
    },
    setBookingStatus(state, action: PayloadAction<[]>) {
      state.bookingStatus = action.payload;
    },
    setBookingTags(state, action: PayloadAction<[]>) {
      state.bookingTags = action.payload;
    },
    setAllocatedTables(state, action: PayloadAction<any[]>) {
      state.allocatedTables = action.payload;
    },
    setSelectedFloorData(state, action: PayloadAction<any>) {
      state.selectedFloorData = action.payload;
    },
    setAllFloorDetails(state, action: PayloadAction<any[]>) {
      state.allFloorDetails = action.payload;
    },
    setFloorLayoutData(state, action: PayloadAction<any[]>) {
      state.floorLayoutData = action.payload;
    },
    setDefaultFloorLayoutData(state, action: PayloadAction<any[]>) {
      state.defaultFloorLayoutData = action.payload;
    },
    setIslocationSwitching(state, action: PayloadAction<boolean>) {
      state.islocationSwitching = action.payload;
    },
    setIsBlockedOpen(state, action: PayloadAction<boolean>) {
      state.isBlockOpen = action.payload;
    },
    setIsBlockedTableOpen(state, action: PayloadAction<boolean>) {
      state.isBlockTableOpen = action.payload;
    },
    setPrePaymentData(state, action: PayloadAction<any>) {
      state.prePaymentData = action.payload;
    },
  },
});
export const {
  setDate,
  setTime,
  setGuest,
  setEmail,
  setFirstName,
  setLastName,
  setPhoneNumber,
  setRequest,
  setOrganizationalDetails,
  setShiftDetails,
  setAvailableSpots,
  setAvailableDaySpots,
  setTableDuration,
  setBookingDetails,
  setLocationId,
  setFloorData,
  setBookingStatus,
  setBookingTags,
  setAllocatedTables,
  setSelectedFloorData,
  setAllFloorDetails,
  setFloorLayoutData,
  setIslocationSwitching,
  setDefaultFloorLayoutData,
  setIsBlockedOpen,
  setIsBlockedTableOpen,
  setPrePaymentData,
} = bookingSlice.actions;
export default bookingSlice.reducer;
